export default __webpack_public_path__ + "static/media/Laura_Ricketts.115b980b.png";